import React, { useState } from "react"
import PropTypes from "prop-types"
import { Card, Checkbox, Divider, Popover, Select } from "antd"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { LockIcon } from "../../../../icons/svg/iconLock"
import { TYPE_QUESTION, TYPE_SURVEY } from "../../../../utils/constants"
import { filter, map } from "lodash"
import "./index.less"
import TextArea from "antd/lib/input/TextArea"
export function QuestionSegments(props) {
  const renderHeader = () => {
    const { isCreate, surveyData, onChangeQuestionForSegments, validateformQuestionDrawer, questionData } = props
    const [colorError, setcolorError] = useState('#979797')
    const [segmentsQuestions, setsegmentsQuestions] = useState({})


    const valueQuestions = (type) => {
      const data = surveyData.segments.map((item, index) => {
        const question = questionData.questions_segments.find(i => i.id_segment === item.id_segment)
        if (type == 2) {
          return (question != null ? question.name : '');
        } else {
          return (question != null ? true : false);
        }

      }
      );
      return data;
    }
    const [checkedState, setCheckedState] = useState(
      isCreate ? new Array(surveyData.segments.length).fill(true) : valueQuestions(1)
    );
    const [questionDataSeg, setquestionData] = useState(
      isCreate ? new Array(surveyData.segments.length).fill('') : valueQuestions(2)
    );
    const handleOnChange = (position) => {
      const updatedCheckedState = checkedState.map((item, index) =>
        index === position ? !item : item
      );
      setCheckedState(updatedCheckedState);
      if(!props.isCreate){

        surveyData.segments.map((item, index) => {
          const question = questionData.questions_segments.find(i => i.id_segment === item.id_segment)
          if (question) {
            item.question=question.name
            item.id_question_has_segment=question.id_question_has_segment
          } else{
            item.question=''
          }

          return item;
        })

      }

      const segments = surveyData.segments.map((i, index) => {
        i.checked = updatedCheckedState[index]
        // si el checkbox esta desmarcado, se limpia el campo de texto
        if (updatedCheckedState[index] == false){
          i.question = ''

        }


        return i
      })
      //se actualiza
      if(!isCreate){
        surveyData.segments[position].question='';
      }
      const valid = updatedCheckedState.some((x) => x == true);
      (valid) ? setcolorError('#979797') : setcolorError('#E37879')

      // si ningun checkbox esta marcado o si alguno de los campos de texto esta vacio, se muestra el error y se deshabilita el boton de guardar
      if (!valid || segments.some(segment => segment.question?.trim() == '') ) validateformQuestionDrawer(segments, 1)

      if (questionDataSeg != undefined && updatedCheckedState[position] == false) {
        questionDataSeg[position] = ''
      }
    };



    const OnChangeQuestion = (indexQ, item, value) => {
      const updatedquestionData = questionDataSeg.map((item, index) =>
        index === indexQ ? value : item
      );

      setquestionData(updatedquestionData);
      const segments = surveyData.segments.map((i, index) => {
        i.checked = checkedState[index]
        if (i.question == undefined){
          i.question = ''
          if(!props.isCreate){
            const question = questionData.questions_segments.find(indice => indice.id_segment === i.id_segment)
            if (question) {
              i.question=question.name
            }
        }
        }
        if (indexQ == index) i.question = value

        return i
      })

      setsegmentsQuestions(segments)
      validateformQuestionDrawer(segments, 2);

    };

    return (
      <div className="QuestionSegments">
        <div className="QuestionSegments__Header">
          <div className="QuestionSegments__Header--left">
            <span className="QuestionSegments__Header--title">Segmentos</span>
          </div>

        </div>
        <div className="QuestionSegments__Content">
          <div>
            <span style={{ fontSize: "13px", color: "#979797" }}>
              Selecciona los segmentos que <strong>responderán la pregunta </strong>marcando la casilla.
              Podrás <strong>personalizar el enunciado</strong> de cada segmento en el cuadro de texto debajo.
            </span>
          </div>
          <div>
            <span style={{ fontSize: "13px", color: colorError }}>
              Deberás <strong>marcar por lo menos un segmento</strong> al cual estará dirigido la pregunta.
            </span>
          </div>
          {
            surveyData.segments.map((item, index) => (

              <div key={item.id_segment} style={{ marginTop: "12px" }}>
                <Card title={<Checkbox checked={checkedState[index]}
                  disabled={isCreate ? false : (surveyData.measures_in_use_count==0 ? false:true)}
                  onChange={() => handleOnChange(index, item)} >
                  <div>
                    <span>{item.name}</span>
                  </div>
                </Checkbox>} size="small">

                  <TextArea className="textarea"
                    maxLength={200}
                    value={questionDataSeg[index]}
                    bordered={false} disabled={!checkedState[index]}
                    placeholder="Escribe aquí tu pregunta para el segmento..."
                    onChange={(e) => OnChangeQuestion(index, item, e.target.value)}
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  />
                </Card>
              </div>

            ))
          }
        </div>
      </div>

    )
  }
  return (
    <>
      <Divider style={{ margin: "16px 0" }} />
      <div className="QuestionSegments">
        {renderHeader()}
      </div>
    </>
  )
}
QuestionSegments.propTypes = {
  isCreate: PropTypes.bool,
  questionData: PropTypes.object,
  surveyData: PropTypes.object,
  idQuestionType: PropTypes.number,
  onChangeQuestionForSegments: PropTypes.func,
  validateformQuestionDrawer: PropTypes.func,
  engagementCheck: PropTypes.bool,
  questionTypes: PropTypes.array,
}
export default QuestionSegments
